import player from "./player"

export default {
  modules: {
    player
  },
};
